import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { SMS_TEMPLATE_CONTROLLER } from "api/Service";

const useSmsTemplates = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["smsTemplatesAll", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${SMS_TEMPLATE_CONTROLLER}`
      );

      const templates = [{ label: "SMS Templates*", value: "" }];

      if (response && response.data) {
        response.data.forEach((element) => {
          templates.push({
            label: element.name,
            value: element.id,
            text: element.template,
          });
        });
      }

      return templates;
    },
    enabled: !!tenantVal,
  });
};

export { useSmsTemplates };
